import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  getIncidentResponseError,
  getIncidentResponseSuccess,
  submitIncidentResponseError,
  submitIncidentResponseSuccess,
} from './actions'
import { INCIDENT_RESPONSE_REQUEST_ASYNC, SUBMIT_INCIDENT_RESPONSE_ASYNC } from './constants'

const getIncidentResponseEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      INCIDENT_RESPONSE_REQUEST_ASYNC.INITIATE,
      SUBMIT_INCIDENT_RESPONSE_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.incidence)
      return true
    }),
    mergeMap(() =>
      api.settings
        .getIncidenceResponseSettings(state$.value.partnerOptions.selectedCompany?.value)
        .pipe(
          map((response) => getIncidentResponseSuccess(response)),
          catchError((error) => of(epicsErrorHandler(getIncidentResponseError, error))),
          takeUntil(action$.pipe(ofType(INCIDENT_RESPONSE_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const submitIncidentResponseEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_INCIDENT_RESPONSE_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings
        .updIncidenceResponseSettings(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.settings.incidentResponse.self.data
        )
        .pipe(
          map((response) => submitIncidentResponseSuccess(response)),
          catchError((error) => of(epicsErrorHandler(submitIncidentResponseError, error, [400]))),
          takeUntil(action$.pipe(ofType(SUBMIT_INCIDENT_RESPONSE_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(getIncidentResponseEpic, submitIncidentResponseEpic)
